module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-dist__edit-hours"
  }, [_c('div', {
    staticClass: "subject-dist__edit-hours__header",
    style: ({
      'background-color': _vm.subject.color
    })
  }, [_c('h4', [_vm._v(_vm._s(_vm.subject.name) + ", " + _vm._s(_vm.getAllKlasses))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle close-subject_edit",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subject-dist__edit-hours__body"
  }, [_c('h2', {
    staticClass: "marg-20-bottom"
  }, [_vm._v(_vm._s(_vm.getAllKlasses) + " " + _vm._s(_vm.i18n[_vm.locale].has) + " " + _vm._s(_vm.subject.hours) + "\n      " + _vm._s(_vm.i18n[_vm.locale].hours_in_school_year))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "label--large"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_new_hours_for) + " " + _vm._s(_vm.teacher.name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hours),
      expression: "hours"
    }],
    ref: "input_hours",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": _vm.selectAll,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "submit-buttons marg-20-top"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
    staticClass: "submit-button marg-10-left",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].update))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a51b342!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionUserEditHours.vue
// module id = 1743
// module chunks = 1